import type { MCPToolInfo } from "@/components/MCP/mcpCredentials";

// ``Credential.metadata.mcp`` as the backend stores it. Availability is
// deny-based (``disabled_tools``); rows persisted before that change still
// carry the old ``enabled_tools`` allow list, which the backend migrates on
// read but never rewrites, so both shapes reach the UI.
export interface MCPStateMeta {
  catalog_key?: string;
  server_url?: string;
  transport?: string;
  discovered_tools: MCPToolInfo[];
  disabled_tools?: string[];
  enabled_tools?: string[];
  tool_list_hash?: string;
  last_probed_at?: string | null;
}

export function enabledToolNames(state: MCPStateMeta): string[] {
  const names = state.discovered_tools.map((tool) => tool.name);
  if (state.disabled_tools) {
    const disabled = new Set(state.disabled_tools);
    return names.filter((name) => !disabled.has(name));
  }
  if (state.enabled_tools) {
    const enabled = new Set(state.enabled_tools);
    return names.filter((name) => enabled.has(name));
  }
  return names;
}
